import React from 'react';
import SrcSetProps from './src-set.props';

const SrcSet: React.FC<SrcSetProps> = (
    {
        images,
        isMobile,
        alt,
        title,
        lazyLoad,
        className
    }
) => {
    let image: string;
    let imageRetina: string;

    if (isMobile) {
        image = images.mobile;
        imageRetina = images.mobileRetina;
    } else {
        image = images.desktop;
        imageRetina = images.desktopRetina;
    }

    const srcSet = `${image} 1x, ${imageRetina} 2x`;

    return (
        <>
            <img
                src={image}
                alt={alt}
                srcSet={srcSet}
                loading={lazyLoad ? 'lazy' : 'eager'}
                className={className}
                title={title}
            />
        </>
    );
};

export default SrcSet;
